// extracted by mini-css-extract-plugin
export default {"advertFooter":"fErWKD8v"};